import React from "react";
import "./styles.css";

const Spinner: React.FC = () => (
  <div className="container">
    <div className="round">
      <div className="inner" />
    </div>
  </div>
);

export default Spinner;
